// Mobile Navigation
class EnergyOnClyde_MobileNavigation {

    constructor() {
        this.body = document.body;
        this.mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
        this.mobileMenu = document.querySelector('[data-mobile-menu]');
        this.mobileMenuItems = document.querySelectorAll('[data-mobile-menu] .menu-item a');
        this.submenuItems = document.querySelectorAll('.mob-submenu-toggle');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.siteHeader = document.querySelector('.header');

        if(!this.mobileMenuToggle || !this.mobileMenu) return;

        this.addEventListeners();
    }

    addEventListeners() {
        this.mobileMenuItems.forEach((item) => {
            item.addEventListener('click', () => {
                this.toggleNavigation();
            });
        });
    }

    toggleNavigation() {
        if (this.mobileMenuToggle.classList.contains('active')) {
            this.body.classList.remove('no-scroll');
            this.pageOverlay.classList.remove('visible');
            this.mobileMenuToggle.classList.remove('active');
            this.mobileMenu.classList.remove('open');
            this.siteHeader.classList.remove('menu-open');
        } else {
            this.body.classList.add('no-scroll');
            this.pageOverlay.classList.add('visible');
            this.mobileMenuToggle.classList.add('active');
            this.mobileMenu.classList.add('open');
            this.siteHeader.classList.add('menu-open');
        }
    }
}

new EnergyOnClyde_MobileNavigation();